<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text class="font-weight-bold">
        Are you sure you want to delete this application?
      </v-card-text>
      <v-card-text class="py-0 text-center">
        <span class="text-uppercase text-danger">This action cannot be undone </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      leaveApplication: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.onBehalfLeaveApplications().delete(this.leaveApplication.id)
          .then(response => {
            this.$emit('deleted')
            this.$snack({ message: 'Record deleted' })
          }).catch(() => {
            this.progressing = false
          })
      },
    },
  }
</script>
